import React from "react";
import PropTypes from "prop-types";

import Addresses from "../../../components/entities/address/AddressForm";
import "../entityonboard.scss";

const RegisteredAddress = (props) => {
  const { regAddData, enableEntityPlus, setRegAddData } = props;

  return (
    <div className="Onboard-Address container">
      <div>
        <h4 className="address-heading">Addresses</h4>
      </div>
      <Addresses
        regAddData={regAddData}
        enableEntityPlus={enableEntityPlus}
        setRegAddData={setRegAddData}
      />
    </div>
  );
};

RegisteredAddress.propTypes = {
  setRegAddData: PropTypes.func,
  regAddData: PropTypes.object,
};
export default RegisteredAddress;
